export default "__VITE_ASSET__DcTT0J4e__"